import { SwitchButton } from "components/switchButton";
import { IAdminAccountRoleItem } from "interfaces";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import moment from "moment";
import { isHaveActionPermission } from "utills/helpers";

interface AdminAccountRoleTableProps {
  data?: IAdminAccountRoleItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const AdminAccountRoleTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: AdminAccountRoleTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Role name
              </th>
              <th scope="col" className="th">
                Created at
              </th>
              <th scope="col" className="th">
                Created by
              </th>
              <th scope="col" className="th">
                Updated at
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th w-28">
                <span className="sr-only">Action</span>
                <p className="">Action</p>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IAdminAccountRoleItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td">
                  {item.name}
                </td>
                <td className="td">
                  {item.created ? moment(item.created).format("DD/MM/YYYY HH:mm:ss") : ""}
                </td>
                <td className="td">
                  {item.created_by}
                </td>
                <td className="td">
                  {item.updated ? moment(item.updated).format("DD/MM/YYYY HH:mm:ss") : ""}
                </td>
                <td className="td overflow-x-auto">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={!isHaveActionPermission("role", "admin", "edit")}
                    onChange={() => _toggleActive(item.id, !item.is_active)}
                  />
                </td>
                <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="flex justify-start items-end gap-x-2 ">
                    <Link to={`/admin-accounts/roles/${item.id}`} className="w-fit">
                      <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                        <EyeIcon className="w-4 h-4 text-black" />
                      </Button>
                    </Link>
                    {isHaveActionPermission("role", "admin", "edit") ? (
                      <Link
                        to={`/admin-accounts/roles/${item.id}/edit`}
                        className="w-fit"
                      >
                        <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                          <PencilIcon className="w-4 h-4 text-black" />
                        </Button>
                      </Link>
                    ) : <></>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
